import {
  ContainerDirective,
  LeafDirective,
  TextDirective,
} from 'mdast-util-directive'
import { VFile } from 'vfile'

const processMagicLink = (
  node: TextDirective | LeafDirective | ContainerDirective,
  index: number,
  parent: any,
  file: VFile
) => {
  let url: string = ''

  if ('attributes' in node && node.attributes !== undefined) {
    if ('id' in node.attributes) {
      url = node.attributes.id
    } else if ('anchor' in node.attributes) {
      url = node.attributes.anchor
    } else {
      file.fail(
        'Expected `id` or `anchor` attribute on magic-link directive',
        node
      )
    }
  } else {
    file.fail(
      'Expected `id` or `anchor` attribute on magic-link directive',
      node
    )
  }

  node.data = node.data ?? {}
  node.data.hName = 'div'
  node.data.hProperties = {
    className: 'magic-link',
  }

  const linkElement = {
    type: 'link',
    url: url,
    children: [node.children[0]],
  }

  parent.children.splice(index, 1, linkElement)
}

export default processMagicLink
